import config from '@/modules/banking/config'
import request from '@/modules/base/util/request'
import pollTransaction from './pollTransaction'
import lang from '@/lang'
import { generateProcessId, getProcessIdHeader } from '@/modules/banking/_helpers/generateProcessId'

export const startPinUpdatePollRequest = (bankContactId, pinData, processId = null, { withoutDeletePin }) => {
  const { urls } = config
  const urlDeletePin = urls.bankContactPin(bankContactId)
  const urlStorePin = urls.bankContactPin(bankContactId)

  pinData.silent = true
  pinData.contactId = bankContactId
  if (!processId) {
    processId = generateProcessId()
  }
  let deletePinPromise = Promise.resolve(null)
  if (!withoutDeletePin) {
    deletePinPromise = request(urlDeletePin, { method: 'DELETE', auth: true, headers: { ...getProcessIdHeader(processId) } })
  }
  return deletePinPromise
    .then(() => {
      return request(urlStorePin, { method: 'PUT', auth: true, headers: { ...getProcessIdHeader(processId) } })
    })
    .then(({ body: { data } }) => {
      if (!data) {
        return Promise.reject(new Error(lang.noBankingPsd2Transaction))
      }
      return pollTransaction({ ...data, meta: pinData }, 'bookingApi', processId)
    })
    .then((result) => {
      return Promise.resolve(result)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export default startPinUpdatePollRequest
